import React, { useContext } from "react";
import { Backdrop, Box, CircularProgress } from "@mui/material";
import { ThemeProvider, alpha } from "@mui/material/styles";
import { DataContext } from "../context/DataContext";
import { crearTema } from "../theme/theme";

const Loading = () => {
  const { isLoading, icon, isDarkMode } = useContext(DataContext);

  // Este overlay también se pinta fuera del armazón (arranque, Login), donde no hay
  // ThemeProvider: lleva el suyo para usar siempre los colores de la marca.
  const tema = crearTema(isDarkMode ? "dark" : "light");

  return (
    <ThemeProvider theme={tema}>
      <Backdrop
        open={isLoading}
        role="status"
        aria-label="Cargando"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1000,
          // Fondo translucido segun el tema en vez del negro fijo del Backdrop, para que
          // el contenido de atras siga leyendose mientras carga.
          backgroundColor: (theme) =>
            alpha(theme.palette.background.default, isDarkMode ? 0.72 : 0.78),
          backdropFilter: "blur(3px)",
        }}
      >
        {/* Texto solo para lectores de pantalla */}
        <Box
          component="span"
          sx={{
            position: "absolute",
            width: 1,
            height: 1,
            overflow: "hidden",
            clip: "rect(0 0 0 0)",
            whiteSpace: "nowrap",
          }}
        >
          Cargando
        </Box>

        <Box
          sx={{
            position: "relative",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* Anillo giratorio */}
          <CircularProgress
            size={140}
            thickness={2.2}
            disableShrink
            sx={{
              color: "primary.main",
              // Extremos redondeados: se ve mas limpio que el corte recto por defecto.
              "& .MuiCircularProgress-circle": { strokeLinecap: "round" },
            }}
          />

          {/* Halo que late detras del logo, para que el pulso se note aunque el logo
              sea de color claro sobre fondo claro. Con "reducir movimiento" no se dibuja. */}
          <Box
            aria-hidden="true"
            sx={{
              position: "absolute",
              width: 104,
              height: 104,
              borderRadius: "50%",
              backgroundColor: "primary.main",
              animation: "crediHalo 1.8s ease-in-out infinite",
              "@keyframes crediHalo": {
                "0%, 100%": { transform: "scale(0.82)", opacity: 0.1 },
                "50%": { transform: "scale(1)", opacity: 0.22 },
              },
              "@media (prefers-reduced-motion: reduce)": {
                display: "none",
              },
            }}
          />

          {/* Logo de la empresa con pulso */}
          <Box
            component="img"
            src={icon}
            alt=""
            sx={{
              position: "absolute",
              width: 78,
              height: 78,
              objectFit: "contain",
              animation: "crediPulse 1.8s ease-in-out infinite",
              "@keyframes crediPulse": {
                "0%, 100%": { transform: "scale(0.9)", opacity: 0.85 },
                "50%": { transform: "scale(1.06)", opacity: 1 },
              },
              // Respeta a quien tenga reducidas las animaciones en su sistema.
              "@media (prefers-reduced-motion: reduce)": {
                animation: "none",
                opacity: 1,
              },
            }}
          />
        </Box>
      </Backdrop>
    </ThemeProvider>
  );
};

export default Loading;
